import { CUSTOM_ELEMENTS_SCHEMA, Component } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/providers/api/api.service';
import { DeviceFindModalResult } from 'src/app/model';
import { HelperProvider } from 'src/app/providers/helper/helper';
import { DeviceInputComponent } from 'src/app/components/device-input/device-input.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-device-find',
  templateUrl: './device-find.modal.html',
  styleUrls: ['./device-find.modal.scss'],
  standalone: true,
  imports: [IonicModule, DeviceInputComponent, FormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DeviceFindModalComponent {
  public deviceId: string;
  public error: string;

  constructor(
    private modalController: ModalController,
    private helper: HelperProvider,
    private api: ApiService,
  ) { }

  public async find() {
    this.helper.showLoading();
    this.error = '';
    const result = await this.api.devices.getDeviceById(this.deviceId);

    if (result.error) {
      this.error = result.error;
      this.helper.hideLoading();
      return false;
    }

    if (result.device?.position_id) {
      const { devices } = await this.api.devices.getPositionedDevicesById([this.deviceId], this.helper);

      if (devices?.[0]?.position_id) {
        const modalResult: DeviceFindModalResult = {
          device: devices[0],
        };

        this.modalController.dismiss(modalResult);
      }
    } else {
      this.error = 'Device not positioned';
    }

    this.helper.hideLoading();
    return false;
  }

  newDevice(device: string) {
    this.deviceId = device;
  }
}

